import { useMutation } from '@tanstack/react-query';
import { useNavigationManager } from '@Router/useNavigationManager';
import { RoutesMap } from '@Router/router.types';
import { saveAccountOpeningReason } from '../api/accountOpeningReason';

export const useSendAccountOpeningReason = () => {
  const { navigateToNextPage } = useNavigationManager();
  return useMutation({
    mutationFn: saveAccountOpeningReason,
    mutationKey: ['saveAccountOpeningReason'],
    onSuccess: () => {
      navigateToNextPage(RoutesMap.ACCOUNT_OPENING_REASON);
    },
  });
};
